import { styled } from 'baseui'

export const BoardPageWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  width: '100%',
})

export const FieldsColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.3125rem',
  marginBottom: '0.125rem',
})

export const ActionsRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  marginTop: '0.625rem',
})
